import { pdfjs } from "react-pdf";
import workerSrc from "pdfjs-dist/build/pdf.worker.min.mjs?url";

// MUST be set immediately at module load
pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

// Optional sanity check (remove later)
console.log("[pdfjs] workerSrc =", workerSrc);